import { shallowRef } from 'vue'
import { useAccountsById } from './useAccountsById'

const account = shallowRef(null)
const budget = shallowRef(null)
const campaign = shallowRef(null)
const adGroup = shallowRef(null)

export function useBreadcrumbState () {
  const updateBreadcrumbsFromAncestors = (activeItem, ancestors) => {
    // Update account
    const { getAccountsById } = useAccountsById()
    const currentAccountPlanId = activeItem?.accountPlanId
    account.value = getAccountsById().get(currentAccountPlanId) || null

    // Update budget
    if (activeItem?.planType === 'budget') {
      budget.value = activeItem
    } else {
      budget.value = ancestors.budgetPlan || null
    }

    // Update campaign
    if (activeItem?.planType === 'campaign') {
      campaign.value = activeItem
    } else {
      campaign.value = ancestors.campaignPlan || null
    }

    // Update adGroup
    if (activeItem?.planType === 'adGroup') {
      adGroup.value = activeItem
    } else {
      adGroup.value = ancestors.adGroupPlan || null
    }
  }

  const clearBreadcrumbs = () => {
    account.value = null
    budget.value = null
    campaign.value = null
    adGroup.value = null
  }

  return {
    account,
    budget,
    campaign,
    adGroup,
    updateBreadcrumbsFromAncestors,
    clearBreadcrumbs
  }
}
